<script>
  import { onMount, onDestroy } from "svelte";

  export let value = "";
  export let placeholder = "Tulis deskripsi dengan format Markdown...";
  export let height = "240px";
  export let textareaTestId = "markdown-editor-textarea";

  let editorContainer;
  let editorInstance;
  let destroyed = false;

  onMount(async () => {
    try {
      // Dimuat secara lazy agar bundle awal (halaman login/daftar) tetap ringan
      const [{ default: Editor }] = await Promise.all([
        import("@toast-ui/editor"),
        import("@toast-ui/editor/dist/toastui-editor.css"),
      ]);
      if (destroyed) return;

      editorInstance = new Editor({
        el: editorContainer,
        height: height,
        initialEditType: "markdown",
        previewStyle: "tab",
        initialValue: value || "",
        placeholder: placeholder,
        usageStatistics: false,
        hideModeSwitch: false,
        events: {
          change: () => {
            value = editorInstance.getMarkdown();
          },
        },
      });
    } catch {
      editorInstance = null;
    }
  });

  $: if (editorInstance && value !== editorInstance.getMarkdown()) {
    editorInstance.setMarkdown(value || "");
  }

  function onTextareaInput(e) {
    value = e.target.value;
    if (editorInstance) {
      editorInstance.setMarkdown(e.target.value);
    }
  }

  onDestroy(() => {
    destroyed = true;
    if (editorInstance) {
      editorInstance.destroy();
      editorInstance = null;
    }
  });
</script>

<div class="toastui-editor-wrapper">
  <!-- Fallback hidden textarea with data-testid for accessibility and test compatibility -->
  <textarea
    data-testid={textareaTestId}
    {value}
    on:input={onTextareaInput}
    class="hidden"
    tabindex="-1"
    aria-hidden="true"
  ></textarea>
  <div bind:this={editorContainer} data-testid="markdown-editor-container"></div>
</div>

<style>
  .toastui-editor-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
  }
  .toastui-editor-wrapper > div[data-testid="markdown-editor-container"] {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  :global(.toastui-editor-wrapper .toastui-editor-defaultUI) {
    display: flex;
    flex-direction: column;
    height: 100%;
    border: 1px solid #e2e8f0;
    border-radius: 0.75rem;
    overflow: hidden;
    font-family: inherit;
  }
  :global(.toastui-editor-wrapper .toastui-editor-main) {
    flex: 1;
    min-height: 0;
  }
  :global(.toastui-editor-wrapper .toastui-editor-toolbar) {
    background-color: #f8fafc;
    border-bottom: 1px solid #f1f5f9;
  }
  :global(.toastui-editor-wrapper .toastui-editor-contents) {
    font-family: inherit;
    font-size: 0.875rem;
  }
</style>
